(() => {
  if (window.__HEALTHZERI_BUY_NOW_GUARD__) return;
  window.__HEALTHZERI_BUY_NOW_GUARD__ = '2026-08-21.1';

  const nativeFetch = window.fetch.bind(window);
  const gid = (type, id) => `gid://shopify/${type}/${String(id).replace(/^gid:\/\/shopify\/[^/]+\//, '')}`;
  const centsToAmount = (value) => Number(value || 0) / 100;
  let checkoutRunning = false;
  let activeButton = null;

  const selectedPurchase = (button) => {
    const product = window.yx_product && typeof window.yx_product === 'object' ? window.yx_product : {};
    const form = document.querySelector('form[data-product-form]');
    if (!form) throw new Error('The product form could not be read');

    const variantId = String(button?.dataset?.variantId || form.querySelector('[data-variant-id-input]')?.value || '');
    const variant = (product.variants || []).find((item) => String(item.id) === variantId);
    if (!variant) throw new Error('The selected bundle could not be read');

    const purchaseType = typeof window.getSelectedPurchaseType === 'function'
      ? window.getSelectedPurchaseType()
      : (() => {
          const input = form.querySelector('[data-purchase-type]:checked');
          return {
            type: input?.value === 'subscription' ? 'subscription' : 'onetime',
            sellingPlanId: input?.dataset?.sellingPlanId || '',
            deliveryText: input?.dataset?.deliveryText || '',
          };
        })();
    const sellingPlanId = purchaseType.type === 'subscription'
      ? String(purchaseType.sellingPlanId || form.querySelector('[name="selling_plan"]:not(:disabled)')?.value || '')
      : '';
    const allocation = (variant.selling_plan_allocations || []).find(
      (item) => String(item.selling_plan_id) === sellingPlanId
    );
    if (purchaseType.type === 'subscription' && (!sellingPlanId || !allocation)) {
      throw new Error('The selected subscription plan could not be validated');
    }

    const quantity = Math.max(1, Number(form.querySelector('[name="quantity"]')?.value || 1));
    const finalPrice = Number(allocation?.price ?? variant.price ?? 0);
    const handle = product.handle || location.pathname.split('/products/')[1]?.split(/[?#/]/)[0] || '';
    const image = variant.featured_image?.src || variant.featured_image || product.featured_image || '';

    return {
      productId: Number(product.id || 0),
      productTitle: product.title || document.querySelector('[data-product-root] h1')?.textContent?.trim() || '',
      variantId: Number(variantId),
      variantTitle: variant.public_title || variant.title || '',
      sku: variant.sku || '',
      finalPrice,
      quantity,
      image,
      url: `/products/${handle}?variant=${variantId}`,
      grams: Number(variant.grams || variant.weight || 0),
      currency: window.Shopify?.currency?.active || 'USD',
      sellingPlan: allocation ? {
        id: Number(sellingPlanId),
        name: purchaseType.deliveryText || 'Delivered every 30 Days | Cancel Anytime',
        groupId: allocation.selling_plan_group_id || '',
      } : null,
    };
  };

  const createIndependentCart = async (purchase) => {
    const response = await nativeFetch('/api/2026-07/graphql.json', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        query: `mutation HealthzeriIndependentCart($merchandiseId: ID!, $quantity: Int!, $sellingPlanId: ID) {
          cartCreate(input: { lines: [{ merchandiseId: $merchandiseId, quantity: $quantity, sellingPlanId: $sellingPlanId }] }) {
            cart {
              id
              totalQuantity
              lines(first: 1) {
                nodes {
                  quantity
                  merchandise { ... on ProductVariant { id } }
                  sellingPlanAllocation { sellingPlan { id } }
                }
              }
            }
            userErrors { field message }
          }
        }`,
        variables: {
          merchandiseId: gid('ProductVariant', purchase.variantId),
          quantity: purchase.quantity,
          sellingPlanId: purchase.sellingPlan ? gid('SellingPlan', purchase.sellingPlan.id) : null,
        },
      }),
    });
    const payload = await response.json().catch(() => ({}));
    const result = payload?.data?.cartCreate;
    const errors = result?.userErrors || [];
    const cart = result?.cart;
    const line = cart?.lines?.nodes?.[0];
    const actualVariant = Number(String(line?.merchandise?.id || '').split('/').pop());
    const actualPlan = line?.sellingPlanAllocation?.sellingPlan?.id
      ? Number(String(line.sellingPlanAllocation.sellingPlan.id).split('/').pop())
      : null;
    const expectedPlan = purchase.sellingPlan?.id || null;

    if (!response.ok || errors.length || !cart?.id || Number(cart.totalQuantity) !== purchase.quantity ||
        Number(line?.quantity) !== purchase.quantity || actualVariant !== purchase.variantId || actualPlan !== expectedPlan) {
      throw new Error(errors.map((item) => item.message).join(', ') || 'The independent cart did not match the selected purchase');
    }
    return cart.id;
  };

  const checkoutPayload = (purchase, cartToken) => {
    const unitPrice = centsToAmount(purchase.finalPrice);
    const totalPrice = unitPrice * purchase.quantity;
    return {
      cart: {
        items: [{
          variantId: gid('ProductVariant', purchase.variantId),
          quantity: purchase.quantity,
          title: purchase.variantTitle ? `${purchase.productTitle} - ${purchase.variantTitle}` : purchase.productTitle,
          variant: purchase.variantTitle,
          originalPrice: unitPrice,
          price: unitPrice,
          linePrice: totalPrice,
          totalDiscount: 0,
          productId: gid('Product', purchase.productId),
          url: purchase.url,
          image: purchase.image,
          weight: purchase.grams,
          weightUnit: 'GRAMS',
          currencyCode: purchase.currency,
          sellingPlanId: purchase.sellingPlan?.id || null,
          sellingPlanName: purchase.sellingPlan?.name || '',
          sellingPlanGroupId: purchase.sellingPlan?.groupId || '',
        }],
        cartToken,
        originalTotalPrice: totalPrice,
        totalPrice,
        totalDiscount: 0,
        totalWeight: purchase.grams * purchase.quantity,
        itemCount: purchase.quantity,
        currency: purchase.currency,
      },
      position: { countryCode: window.Shopify?.country || 'US', regionCode: '', city: '' },
      checkoutId: '',
      language: window.Shopify?.locale || 'en',
      extra: {
        view: 'default',
        sourceUrl: `${location.origin}${location.pathname}?view=default&healthzeriIndependentCheckout=2026-08-21.1`,
        healthzeriIndependentCheckout: '2026-08-21.1',
        cookie_id: '',
      },
    };
  };

  const callCheckout = async (path, body) => {
    const shopifyId = String(window.Shopify?.shop || '').split('.')[0];
    if (!shopifyId) throw new Error('The Shopify store ID could not be read');
    const response = await nativeFetch(`https://us.ouyifyapi.com${path}`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Shopify-Id': shopifyId, oyAppVersion: 'v2' },
      body: JSON.stringify(body),
    });
    const payload = await response.json().catch(() => ({}));
    if (!response.ok || (payload.code != null && Number(payload.code) !== 200)) {
      throw new Error(payload.message || `Checkout failed (${response.status})`);
    }
    return payload.data ?? payload;
  };

  const paypalUrl = (payload) => {
    const data = payload?.data ?? payload ?? {};
    const direct = String(data.paypalPaymentUrl || '').trim();
    if (direct && !/\/thanks|\/paypal\/return|\/confirm-address/i.test(direct)) return direct;
    for (const rel of ['payer-action', 'approve']) {
      const url = String(data.paypalOrder?.links?.find((link) => link?.rel === rel)?.href || '').trim();
      if (/paypal\.com/i.test(url)) return url;
    }
    return String(data.redirectUrl || data.paymentUrl || '').trim();
  };

  const setLoading = (button) => {
    activeButton = button;
    button.dataset.healthzeriOriginalHtml = button.innerHTML;
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    button.textContent = button.id === 'yx_paypal_checkout' ? 'CONNECTING TO PAYPAL…' : 'LOADING SECURE CHECKOUT…';
    const overlay = document.createElement('div');
    overlay.id = 'healthzeri-checkout-processing';
    overlay.setAttribute('role', 'status');
    overlay.textContent = 'Processing secure checkout…';
    Object.assign(overlay.style, {
      position: 'fixed', inset: '0', zIndex: '2147483000', display: 'grid', placeItems: 'center',
      background: 'rgba(255,255,255,.92)', color: '#1f2e5b', font: '700 24px Arial,sans-serif'
    });
    document.body.append(overlay);
  };

  const resetLoading = () => {
    document.querySelector('#healthzeri-checkout-processing')?.remove();
    document.querySelectorAll('[data-healthzeri-original-html]').forEach((button) => {
      button.innerHTML = button.dataset.healthzeriOriginalHtml;
      delete button.dataset.healthzeriOriginalHtml;
      button.disabled = false;
      button.removeAttribute('aria-busy');
    });
    activeButton = null;
    checkoutRunning = false;
  };

  window.addEventListener('pagehide', resetLoading);
  window.addEventListener('pageshow', resetLoading);

  const start = async (button) => {
    if (checkoutRunning) return;
    checkoutRunning = true;
    let navigating = false;
    setLoading(button);
    try {
      const purchase = selectedPurchase(button);
      const cartToken = await createIndependentCart(purchase);
      const body = checkoutPayload(purchase, cartToken);
      if (button?.id === 'yx_paypal_checkout') {
        const created = await callCheckout('/api/checkout/paypal', body);
        const url = paypalUrl(created);
        if (!url) throw new Error('PayPal payment URL was not returned');
        const target = new URL(url, location.origin);
        if (!target.searchParams.has('useraction')) target.searchParams.set('useraction', 'commit');
        if (!target.searchParams.has('fundingSource')) target.searchParams.set('fundingSource', 'paypal');
        navigating = true;
        location.assign(target.href);
        return;
      }
      const checkout = await callCheckout('/api/checkout', body);
      if (!checkout.checkoutId) throw new Error('Checkout ID was not returned');
      navigating = true;
      location.assign(`/a/s/checkout/${checkout.checkoutId}`);
    } catch (error) {
      console.error('[Healthzeri independent checkout]', error);
      alert('Checkout could not be started. Please try again.');
    } finally {
      checkoutRunning = false;
      if (!navigating) resetLoading();
    }
  };

  window.__HEALTHZERI_START_BUY_NOW__ = start;
  document.documentElement.dataset.healthzeriBuyNowHandler = 'independent-selected-purchase';
  window.dispatchEvent(new CustomEvent('healthzeri:buy-now-ready', { detail: start }));
})();
